<template>
    <div class="area-content-body">
        <div v-if="!canRead" class="no-permission-message">
            Sie haben keine Berechtigung, die Benutzerverwaltung zu öffnen.
        </div>
        <DxDataGrid v-else class="admin-users-grid" :focused-row-enabled="true"
                    :auto-navigate-to-focused-row="autoNavigateToFocusedRow"
                    key-expr="_id"
                    :data-source="users"
                    @cell-prepared="cellPrepared"
                    @saving="saving">
            <DxEditing :allow-updating="canWrite"
                       :allow-deleting="canDelete"
                       :allow-adding="canWrite"
                       mode="row"
                       new-row-position="last"
                       :useIcons="true" />
            <DxColumn data-field="_id" :visible="false" :header-filter="{allowSearch:false}" :allow-search="false" :allow-filtering="false"></DxColumn>
            <DxColumn data-field="firstName" caption="Vorname" />
            <DxColumn data-field="lastName" caption="Nachname" />
            <DxColumn data-field="eMail" caption="Email" />
            <DxColumn data-field="phoneNumber" caption="Telefon" />
            <DxColumn data-field="mobileNumber" caption="Mobil" />

            <DxColumn data-field="roleId" caption="Rolle">
                <DxLookup :data-source="roles"
                          value-expr="_id"
                          display-expr="name"
                          :allow-clearing="true" />
            </DxColumn>

            <DxColumn data-field="_id" cell-template="signatureTemplate" caption="Unterschrift" :allow-editing="false" />
            <DxColumn data-field="address" caption="Adresse" />
            <DxColumn data-field="color" caption="Farbe" edit-cell-template="colorTemplate" cell-template="colorViewTemplate" />
            <DxColumn data-field="radius" caption="Reichweite" data-type="number" />
            <template #colorTemplate="{data}">
                <DxColorBox :value="data.value" @value-changed="data.setValue($event.value)"></DxColorBox>
            </template>
            <template #colorViewTemplate="{data}">
                <div :style="{width: '100%', height: '19px',borderRadius: '9px',backgroundColor:data.value}"></div>
            </template>
            <template #signatureTemplate="{ data }">
                <ImageViewer v-if="data.value" :attachment="{assignment:data.value,assignmentType:'user',name:'Signature.png'}" height="32px" class="parent-class-remove" :minimal="true" allowed-types="image/*" :pop-up-on-click="true" :show-upload-in-full-screen="canWrite" :show-delete-in-full-screen="canWrite"></ImageViewer>
                <div v-else></div>
            </template>
            <DxColumn data-field="pl" caption="PL" />
            <DxColumn type="buttons"
                      :width="110">
                <DxButton name="edit" />
                <DxButton name="delete" />
                <DxButton hint="Zurücksetzen"
                          :visible="canWrite"
                          icon="refresh"
                          :disabled="isCloneIconDisabled"
                          @click="reset" />
            </DxColumn>
            <DxSearchPanel :visible="true" />
        </DxDataGrid>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import DxDataGrid,{        
        DxColumn,
        DxEditing,
        DxSearchPanel,
        DxButton,
        DxLookup
    } from 'devextreme-vue/data-grid';
    import { DxColorBox } from 'devextreme-vue';
    import ImageViewer from "../components/image-viewer.vue";

    import userApi from '../services/UserApi';
    import roleApi from '../services/RoleApi';

    import { confirm } from 'devextreme/ui/dialog';

    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    export default defineComponent({
        components: {
            DxDataGrid,
            DxColumn,
            DxEditing,
            ImageViewer,
            DxSearchPanel,
            DxButton,
            DxColorBox,
            DxLookup
        },
        data() {
            return {
                users: [],
                roles: [],               
            };
        },
        async created() {
            await this.fetchData();
        },
        computed: {
            canRead() {                     
                return meApi.hasPermissionSync(AppPermissions.AdminUsers.Read);                
            },
            canWrite() {
                return meApi.hasPermissionSync(AppPermissions.AdminUsers.Write);
            },
            canDelete() {
                return meApi.hasPermissionSync(AppPermissions.AdminUsers.Delete);
            }
        },
        methods: {
            async fetchData(){
                this.users = await userApi.getAll();
                this.roles = (await roleApi.getAll()).sort((a, b) =>
                    (a.name || '').localeCompare(b.name || '')
                );
            },
            async reset(e) {
                if (await confirm(`Wollen Sie das Kennwort von '${e.row.data.firstName} ${e.row.data.lastName}' wirklich zurücksetzen?`, "Kennwort zurücksetzen")) {
                    await userApi.reset(e.row.key);
                }
            },
            async saving(e) {
                if (!this.canWrite) {
                    e.cancel = true;
                    return;
                }

                for(let change of e.changes){
                    if(change.type === "update"){
                        let user = this.users.find(u => u._id === change.key);
                        if (user.eMail != user.eMail.trim())
                            user.eMail = user.eMail.trim();
                        Object.assign(user,change.data);
                    } else if(change.type === "insert") {
                        await userApi.save(change.data);
                    } else if(change.type === "remove") {
                        await userApi.delete(change.key);
                    }
                }
                if(e.changes.some(c=>c.type==="insert")){
                    await this.fetchData();
                }
            },
            cellPrepared(e){
                if(e.column.dataField === '_id' && e.rowType === 'data'){
                    e.cellElement.style.padding = "0";
                }
            }

        },
    });
</script>

<style>
    .admin-users-grid .dx-datagrid {
        padding: 10px;
        background-color: #2a2a2a;
    }
</style>
